export default __webpack_public_path__ + "static/media/logo_business-insider.262d9ac5.svg";